import type React from "react";
import { Helmet } from "react-helmet";

import envs from "env";

import TrialExpiredModal from "./TrialExpiredModal";

const prTitle = envs.get("SUPERBLOCKS_UI_PR_TITLE");
const TITLE_SUFFIX = prTitle || "Superblocks";

export const AGENTS_TITLE = "On-Premise Agents";
export const INVITE_MEMBERS_TITLE = "Invite Members";
export const AUDIT_LOGS_TITLE = "Audit Logs";
export const DOCUMENTATION_TITLE = "Documentation";
export const HOME_TITLE = "Home";
export const INTEGRATIONS_TITLE = "Integrations";

export const PROFILES_TITLE = "Profiles";
export const ENVIRONMENTS_TITLE = "Environments";
export const REPOSITORIES_TITLE = "Repositories";
export const PERMISSIONS_TITLE = "Permissions";
export const ROLES_AND_PERMISSIONS_TITLE = "Roles & Permissions";
export const OBSERVABILITY_TITLE = "Observability";
export const SECRETS_MANAGEMENT_TITLE = "Secrets Management";

export const VIDEO_TITLE = "Videos";

export const PERSONAL_SETTINGS_TITLE = "Personal settings";

export const ADMIN_DOWNLOAD_DBFS = "Download DBFS Folder";

export const PageWrapper = ({
  children,
  pageName,
}: {
  children: React.ReactNode;
  pageName: string | undefined;
}) => {
  return (
    <>
      <TrialExpiredModal />
      <Helmet
        titleTemplate={`%s - ${TITLE_SUFFIX}`}
        defaultTitle={TITLE_SUFFIX}
      >
        {pageName && <title>{pageName}</title>}
      </Helmet>
      {children}
    </>
  );
};
